module.exports = __webpack_public_path__ + "../../../../content/dam/gfps/com/website-tools/carbon-calculator/img/icon_co2.svg";